import TagManager from 'react-gtm-module';

class GtmService {
    constructor() {
        this.isInit = false;
    }

    init() {
        if (!this.isInit) {
            if (
                process.env.REACT_APP_GTM_ID &&
                ['qa', 'staging', 'prod'].includes(process.env.REACT_APP_ENVIRONMENT.toLowerCase())
            ) {
                TagManager.initialize({
                    gtmId: process.env.REACT_APP_GTM_ID
                });
                this.isInit = true;
            }
        }
    }

    sendRouteChangeEvent(page, additionInfo = {}) {
        if (this.isInit) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'route-change',
                    page,
                    ...additionInfo
                }
            });
        }
    }

    sendLoginSuccessEvent(userData, appId) {
        if (this.isInit) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'login-success',
                    user: {
                        id: userData.user_id,
                        title: userData.job_title || ''
                    },
                    app: appId || ''
                }
            });
        }
    }

    sendLogoutSuccessEvent() {
        if (this.isInit) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'logout_success'
                }
            });
        }
    }
}

export default new GtmService();
